import styled from 'styled-components';

export const StoreResultsColumn = styled.div`
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
`;
